import { render } from "./ArrayGame.vue?vue&type=template&id=bf07d494&scoped=true"
import script from "./ArrayGame.vue?vue&type=script&lang=js"
export * from "./ArrayGame.vue?vue&type=script&lang=js"

import "./ArrayGame.vue?vue&type=style&index=0&id=bf07d494&scoped=true&lang=css"

import exportComponent from "D:\\Dev\\devine-mot\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf07d494"]])

export default __exports__